import MainLayout from "../../layout/MainLayout";

import "./service-page.css";

function ServicePage() {
  interface Service {
    title: string;
    content: string;
  }
  const services: Service[] = [
    {
      title: "Modern Web Development",
      content:
        "Build clean, semantic, and high-performance websites using HTML5, CSS3, JavaScript (ES6+), and TypeScript.",
    },
    {
      title: "Reusable & Scalable Code",
      content:
        "Develop maintainable, component-based code with clean architecture and reusable UI patterns.",
    },
    {
      title: "Responsive UI/UX Design",
      content:
        "Craft visually appealing, mobile-first interfaces using Tailwind CSS, Flowbite-React, DaisyUI, and custom styling.",
    },
    {
      title: "React & Next.js Frontend",
      content:
        "Build interactive, optimized, and modern web apps using React, Next.js, Zustand, TanStack Query, and React Hook Form.",
    },
    {
      title: "API Integration & State Handling",
      content:
        "Integrate REST APIs with Axios and TanStack Query, and manage app-wide state with Zustand and Context API.",
    },
    {
      title: "Backend with Express & MongoDB",
      content:
        "Create backend APIs and perform full CRUD operations using Express.js, MongoDB, and Mongoose.",
    },
    {
      title: "UI Design for Angular Projects",
      content:
        "Design user interfaces and implement component styling for Angular-based applications using SCSS, Bootstrap, and custom UI systems.",
    },
    {
      title: "Theming & Component Customization",
      content:
        "Customize UI libraries like Flowbite, DaisyUI, CoreUI, and Bootstrap to match branding and design systems.",
    },
    {
      title: "Performance Optimization",
      content:
        "Optimize UI performance, reduce bundle size, improve loading speed, and enhance overall user experience.",
    },
    {
      title: "Cross-Browser & Cross-Device Compatibility",
      content:
        "Ensure consistent design and functionality across all major browsers and various screen sizes.",
    },
    {
      title: "Fast Debugging & Issue Resolution",
      content:
        "Quickly identify and fix UI bugs, layout issues, and frontend performance problems.",
    },
    {
      title: "Deployment & Hosting",
      content:
        "Deploy applications efficiently to platforms like Vercel, Netlify, and GitHub Pages.",
    },
  ];

  return (
    <MainLayout>
      <div className="flex flex-wrap justify-between lg:max-w-[60rem] mx-auto mt-14">
        {services.map((service, index) => (
          <div
            key={index}
            className="lg:w-[calc(100%/2-26px)] lg:px-0 px-3 lg:mb-14 mb-9 group"
          >
            <div className="service-card border border-gray-600 border-opacity-30 bg-gray-600 bg-opacity-25 px-6 pt-14 pb-8 rounded-2xl relative">
              <p>{service.content}</p>
              <div className="absolute py-[0.875rem] px-7 bg-zinc-800 shadow-sm shadow-gray-700 left-6 top-[-1.25rem] rounded-tl-md rounded-bl-3xl rounded-tr-3xl rounded-br-md group-[:nth-child(4n+1)]:bg-gray-950 group-[:nth-child(4n+4)]:bg-gray-950">
                {service.title}
                <div className="absolute left-2 top-2 w-2 h-2 rounded-full bg-gray-800 border border-gray-400 border-opacity-30"></div>
                <div className="absolute right-2 bottom-2 w-2 h-2 rounded-full bg-gray-700 border border-gray-400 border-opacity-30"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </MainLayout>
  );
}

export default ServicePage;
